'use strict';
module.exports = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);



//////////////////
// WEBPACK FOOTER
// ../~/supporticon/~/strict-uri-encode/index.js
// module id = 1385
// module chunks = 0